import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import getDisplayInformation from '../../../../../components/data-driven-logo/get-display-information';
import messages from '../messages';

import style from '../style.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

/**
 * @param {object} props
 * @param {object} [props.fulfillmentProvider]
 * @param {object} [props.fulfillmentService]
 * @param {Array} [props.fulfillmentProviders]
 * @param {(provider: object) => void} props.setFulfillmentProvider
 * @param {Array} [props.filteredFulfillmentServices]
 * @param {(service: object) => void} props.setFulfillmentService
 * @returns {JSX.Element}
 */
const FulfillmentDropdown = ({
  fulfillmentProvider,
  fulfillmentService,
  fulfillmentProviders = emptyArray,
  setFulfillmentProvider,
  filteredFulfillmentServices = emptyArray,
  setFulfillmentService,
}) => {
  const [dataFulfillmentProviders, setDataFulfillmentProviders] = useState(fulfillmentProviders);
  const defaultMessage = <FormattedMessage {...messages.select} />;
  const shipFromLabel = fulfillmentProvider?.name || defaultMessage;
  const fulfilmentServiceLabel = fulfillmentService?.name || defaultMessage;

  useEffect(() => {
    const displayedFPs = fulfillmentProviders.map((fp) => {
      const displayInfo = getDisplayInformation({
        fillProviderId: parseInt(fp.fulfillmentProviderId, 10),
      });
      return {
        ...fp,
        displayName: displayInfo?.name,
      };
    });
    setDataFulfillmentProviders(displayedFPs);
  }, [fulfillmentProviders, setDataFulfillmentProviders]);

  return (
    <div className={style['service-mapping-box']}>
      <div className={style['service-mapping-title']}>
        <FormattedMessage {...messages.fulfillmentSettings} />
      </div>
      <div className={style['service-mapping-dropdown-container']}>
        <label>
          <FormattedMessage {...messages.shipFrom} />
        </label>
        <DropdownMenu className={style['fulfillment-mapping-dropdown']} dropdownMenuShouldHaveWidthOfButton>
          <DropdownMenuToggler className={style['service-mapping-toggler']} theme='white'>
            {shipFromLabel}
          </DropdownMenuToggler>
          {dataFulfillmentProviders.map((fp) => (
            <DropdownMenuItem key={fp.fulfillmentProviderId} onClick={() => setFulfillmentProvider(fp)}>
              {fp.displayName}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      </div>
      <div className={style['service-mapping-dropdown-container']}>
        <label>
          <FormattedMessage {...messages.service} />
        </label>
        <DropdownMenu className={style['fulfillment-mapping-dropdown']} dropdownMenuShouldHaveWidthOfButton>
          <DropdownMenuToggler className={style['service-mapping-toggler']} theme='white'>
            {fulfilmentServiceLabel}
          </DropdownMenuToggler>
          {filteredFulfillmentServices.map((ffs) => (
            <DropdownMenuItem key={ffs.fulfillmentServiceId} onClick={() => setFulfillmentService(ffs)}>
              {ffs.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
      </div>
    </div>
  );
};

export default FulfillmentDropdown;
